/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespComponents_searchBrowse = {|
  +displayUriRef: ?string;
  +topCategoryL1: ?"furniture" | "fashion" | "jewelry" | "art";
  +totalResults: ?number;
  +displayMaxNumberOfPages: ?number;
  +pageType: ?string;
  +spellCheck: ?{|
    +newQuery: ?string;
    +redirect: ?{|
      +redirectFrom: ?string;
    |};
  |};
  +filters: ?$ReadOnlyArray<?{| |}>;
  +appliedFilters: ?$ReadOnlyArray<?{|
    +name: ?string;
    +values: ?$ReadOnlyArray<?{|
      +urlLabel: ?string;
    |}>;
  |}>;
  +browseContentModule: ?{|
    +description: ?string;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contentModuleId",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespComponents_searchBrowse",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespBrowseHeader_searchBrowse",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "displayUriRef",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "totalResults",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "displayMaxNumberOfPages",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "pageType",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "SpellcheckSuggestions",
      "name": "spellCheck",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "newQuery",
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "SpellcheckSuggestionsRedirected",
          "name": "redirect",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "redirectFrom",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedSearchSuggestions_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedSearchRedirectNotice_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenu_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespContentModule_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResults_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedPageBreadcrumbs_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedTitle_searchBrowse",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "topCategoryL1",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSortItems_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespPageSize_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedTopTileController_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespCategoryTiles_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchProvider_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedBillboardAd_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedSkyscraperAd_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedItems_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespMoreWaysToBrowse_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespPriceTiles_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespTradeOnApprovalPromoBanner_searchBrowse",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseFilter",
      "name": "filters",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SbRespRefineMenu_filters",
          "args": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "name": "appliedFilters",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "name": "values",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "urlLabel",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "contentModuleId",
          "variableName": "contentModuleId",
          "type": "String"
        }
      ],
      "concreteType": "BrowseContentModule",
      "name": "browseContentModule",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "description",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SearchBrowseQueryConnection"
};

module.exports = fragment;
